import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import { getGroupList } from "../../app/api";


const formatDate = (dateString: any) => {
  const date = new Date(dateString);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
};

export const GroupList = () => {
  const [loading, setLoading] = useState(false);
  const {eeljuud, userBio} = useContext(UserContext);
  const [selectedEelj, setSelectedEelj] = useState<any>(undefined);
  const [groupList, setGroupList] = useState([]);
  const [groupListError, setGroupListError] = useState<string | undefined>(undefined);

  const fetchGroupList = useCallback(async (id: string) => {
    setGroupListError(undefined);
    setLoading(true);
    try {
      const resp = await getGroupList({
        eelj_id: id,
      });
      console.log(resp.data);
      if(resp.data) {
        setGroupList(resp.data);
      }
    } catch(err: any) {
      console.log(err);
      setGroupListError(err.response.data.error);
    }
    setLoading(false);
  }, []);

  useEffect(() => {
    if(selectedEelj) {
      fetchGroupList(selectedEelj);
    }
  }, [selectedEelj]);

  return (
    <div className="min-h-screen pt-24 pb-16 bg-gradient-to-br from-primary-50 via-fun-50 to-happy-50">
      {loading && (
        <div className="w-full h-full fixed top-0 left-0 bg-white/80 backdrop-blur-sm z-50 flex items-center justify-center">
          <div className="relative">
            <div className="w-20 h-20 border-4 border-playful-300 border-t-primary-500 rounded-full animate-spin"></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <span className="text-2xl">✨</span>
            </div>
          </div>
        </div>
      )}
      
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {userBio?.role === 'teacher' && (
          <>
            <div className="text-center mb-8 animate-fade-in">
              <div className="inline-block relative">
                <h1 className="text-4xl sm:text-5xl font-bold text-dark-900 mb-4 relative z-10">
                  <span className="relative z-10">👥 Ээлжийн хүүхдүүд</span>
                  <div className="absolute -top-2 -right-2 w-10 h-10 bg-playful-400 rounded-full animate-bounce-slow"></div>
                </h1>
              </div>
            </div>
            
            <div className="bg-white rounded-3xl p-8 md:p-12 shadow-large border-4 border-primary-200 mb-8 animate-slide-up">
              <label className="block mb-4">
                <span className="block text-sm font-bold text-dark-900 mb-2">📅 Ээлж сонгох</span>
                <select 
                  className="w-full px-4 py-3 rounded-xl border-2 border-gray-300 bg-white text-dark-900 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all"
                  onChange={(e) => {setSelectedEelj(e.target.value);}}
                >
                  <option value='' disabled selected hidden>
                    Энд дарж ээлжээ сонгоно уу.
                  </option>
                  {[...eeljuud.activeEelj, ...eeljuud.eelj].map((eelj: any) => (
                    <option key={eelj.id} value={eelj.id}>
                      {eelj.title + ' ' + formatDate(eelj.start_date) + ' -> ' + formatDate(eelj.end_date)}
                    </option>
                  ))}
                </select>
              </label>
            </div>
            
            {groupList && groupList.length > 0 ? (
              <div className="bg-white rounded-3xl shadow-large border-4 border-playful-200 overflow-hidden animate-scale-in">
                <div className="overflow-x-auto">
                  <table className="w-full">
                    <thead className="bg-gradient-to-r from-primary-500 to-fun-500 text-white">
                      <tr>
                        <th className="px-4 py-4 text-left font-bold">Овог</th>
                        <th className="px-4 py-4 text-left font-bold">Нэр</th>
                        <th className="px-4 py-4 text-left font-bold">РД</th>
                        <th className="px-4 py-4 text-left font-bold">Утасны дугаар</th>
                        <th className="px-4 py-4 text-left font-bold">Эцэг эхийн утас</th>
                        <th className="px-4 py-4 text-left font-bold">Линк</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {groupList.map((v: any, index: number) => (
                        <tr key={index} className="hover:bg-primary-50 transition-colors">
                          <td className="px-4 py-4 text-dark-700">{v.user.lastName}</td>
                          <td className="px-4 py-4 text-dark-700 font-semibold">{v.user.firstName}</td>
                          <td className="px-4 py-4 text-dark-600">{v.user.registerNumber}</td>
                          <td className="px-4 py-4 text-dark-600">{v.user.phone}</td>
                          <td className="px-4 py-4 text-dark-600">{v.user.parentPhone}</td>
                          <td className="px-4 py-4">
                            <a 
                              href={`https://nairamdal.mn/profile/${v.user._id}`} 
                              className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-gradient-to-r from-primary-500 to-fun-500 text-white font-semibold text-sm shadow-medium hover:shadow-glow hover:scale-105 transform transition-all duration-300"
                            >
                              Дэлгэрэнгүй →
                            </a>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            ) : selectedEelj ? (
              <div className="bg-white rounded-3xl p-12 text-center shadow-large border-4 border-primary-200 animate-scale-in">
                <div className="text-6xl mb-4">👶</div>
                <p className="text-xl text-dark-600">
                  Таны бүлэгт хүүхэд олдсонгүй.
                </p>
              </div>
            ) : null}
            
            {groupListError && (
              <div className="bg-accent-50 border-2 border-accent-400 text-accent-700 px-6 py-4 rounded-2xl mt-6 animate-scale-in">
                <div className="flex items-center gap-3">
                  <span className="text-2xl">⚠️</span>
                  <span className="font-semibold">{groupListError}</span>
                </div>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  )
}

export default GroupList;